import {Category} from "./category";

export class Subcategory {
  constructor () {}
  subCategoryId: any = '';
  name: any = '';
  categoryByCategoryId: Category = new Category();
}
